import React from 'react';
import Typography from '@mui/material/Typography';
import { Preloader } from '#component/preloader';
import { Card, NoLocations } from './styles';

const { VITE_MAPBOX_GLJS_API } = import.meta.env;

function MapCard(props) {
  const {
    locationsLoading,
    selectedDevices,
    handleClickOpen
  } = props;

  let ll = { timestamp: '' };

  selectedDevices.forEach(device => {
    if (device.locations && device.locations.length > 0) {
      const l = device.locations[device.locations.length - 1];
      if (l.lng ?? l.lat ?? l.timestamp > ll.timestamp) ll = l;
    }
  });

  const getCardWidth = () => {
    const windowWidth = window.innerWidth;

    // To understand check computed layout in chrome devtools
    const OUTER_DIVS_PADDING_SUM = 32;
    const TEN_PERCENTS_OF_FREE_SPACE = 0.1; // card width is 90%
    const CARD_TOTAL_MARGIN = (windowWidth - OUTER_DIVS_PADDING_SUM) * TEN_PERCENTS_OF_FREE_SPACE;

    const cardWidth = Math.ceil(windowWidth - OUTER_DIVS_PADDING_SUM - CARD_TOTAL_MARGIN);
    return cardWidth;
  };

  const staticMapSrc = `//api.mapbox.com/styles/v1/mapbox/light-v10/static/pin-s+000(${ll.lng},${ll.lat})/${ll.lng},${ll.lat},13/${getCardWidth()}x200?logo=false&access_token=${VITE_MAPBOX_GLJS_API}`;

  return (

    <Card onClick={() => handleClickOpen(90)}>
      {locationsLoading && <Preloader style={{ margin: '45px auto 0' }} />}
      {!locationsLoading &&
          (ll.lng ?? ll.lat ?
            <img alt="map" src={staticMapSrc} /> :
            <NoLocations>
              <Typography variant="h4">
                No locations
              </Typography>
            </NoLocations>)}
    </Card>
  );
}

export default MapCard;
